import version from "./version_3";

export default version;
